import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  token:string;
  refreshToken:string;
  decoded:any;
  expDate:Date;

  constructor() { }

}
